// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {readCustomer} from '../../shared/repositories';

export const readCustomerDetails = (id, customerPrivate) =>
    dispatch => {

        dispatch({
            type: actions.INCREASE_BUSY_COUNTER
        });

        return readCustomer(id, customerPrivate)
            .then(data => {

                dispatch({
                    type: actions.DECREASE_BUSY_COUNTER
                });

                dispatch({
                    data,
                    type: actions.READ_CUSTOMER_DETAILS_SUCCESS
                });

            })
            .catch(() => {

                dispatch({
                    ckcCustomerFailed: true,
                    type: actions.UPDATE_CKC_CUSTOMER_FAILURE
                });

                dispatch({
                    type: actions.DECREASE_BUSY_COUNTER
                });

            });

    };



// WEBPACK FOOTER //
// ./src/customer/details/action-creators/details.js